import { render } from "./ManufacturerApp.vue?vue&type=template&id=10ba0f33"
import script from "./ManufacturerApp.vue?vue&type=script&lang=js"
export * from "./ManufacturerApp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__